//
// Navigation
//

const $ = window.jQuery;

$( '.hero-search-button' ).click( openSearch );
$( '.hero-search-modal .overlay' ).click( closeSearch );

//
//
//
function openSearch() {
	$( '.hero-search-modal' ).show();
}

//
//
//
function closeSearch() {
	$( '.hero-search-modal' ).hide();
}
